import React from 'react';
import { useNavigate } from 'react-router-dom';
import ImprovedQuestBuilder from '@/components/ImprovedQuestBuilder';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function QuestBuilderPage() {
  const navigate = useNavigate();

  return (
    <div className="relative">
      {/* Back button overlay */}
      <div className="fixed top-4 left-4 z-50">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate('/')}
          className="shadow-lg"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Назад
        </Button>
      </div>

      <ImprovedQuestBuilder />
    </div>
  );
}
